import { atom } from 'recoil';

export const _noticableOpen = atom<boolean>({
    key: 'noticable-open',
    default: false,
});
